const words = ["Psychometrics", "Curiosity", "Mentorship", "Career Mapping", "Self Discovery", "Confidence", "1-to-1 Guidance"];

export default function Marquee() {
  const row = [...words, ...words];
  return (
    <div className="border-y border-border bg-primary py-4 overflow-hidden" data-testid="editorial-marquee">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((w, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-display text-lg sm:text-xl font-bold text-primary-foreground/90 px-6">{w}</span>
                <span className="w-2 h-2 rounded-full bg-accent inline-block" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
